<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('item_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/stock/item-create" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onShow"><i class="fa fa-file-excel-o"></i> {{$t('import')}}</button>
            <div class="pull-right">
                <div class="btn-group tool-group" role="group">
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(0)" :class="{active:viewType==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(1)" :class="{active:viewType==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row-flex-x">
                        <div>
                            <label class="label-control blue">&nbsp;</label>
                            <input type="text" class="form-control" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                        </div>
                        <div style="min-width: 120px;">
                            <div class="form-group">
                                <label class="label-control blue upper">{{ $t('itemtype') }}</label>
                                <select class="form-control" v-model="query.ProductTypeId" @change="toList">
                                    <option value="">{{$t('all')}}</option>
                                    <option v-for="ret in $productTypes()" :key="ret.id" :value="ret.id">{{$t(ret.lang)}}</option>
                                </select>
                            </div>
                        </div>
                        <div style="min-width: 120px;">
                            <div class="form-group">
                                <label class="label-control blue upper">{{ $t('category') }}</label>
                                <select class="form-control" v-model="query.CategoryId" @change="toList">
                                    <option value="">{{$t('all')}}</option>
                                    <option v-for="ret in categories" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label class="label-control blue">&nbsp;</label>
                                <div>
                                    <button type="button" class="btn btn-default" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="viewType==0">
                        <table class="table table-bordered no-bor v-top">
                            <thead>
                                <tr class="upper">
                                    <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                                    <th class="sorting">
                                        <span class="sort-field" @click="onSort('Num')">{{ $t('item_code') }}</span>
                                        <i class="fa fa-sort" aria-hidden="true"></i>
                                    </th>
                                    <th class="sorting">
                                        <span class="sort-field" @click="onSort('Name')">{{ $t('item_name') }}</span>
                                        <i class="fa fa-sort" aria-hidden="true"></i>
                                    </th>
                                    <th class="sorting">
                                        <span class="sort-field" @click="onSort('ProductTypeId')">{{ $t('itemtype') }}</span>
                                        <i class="fa fa-sort" aria-hidden="true"></i>
                                    </th>
                                    <th class="sorting">
                                        <span class="sort-field" @click="onSort('UomName')">{{ $t('uom') }}</span>
                                        <i class="fa fa-sort" aria-hidden="true"></i>
                                    </th>
                                    <th class="sorting">
                                        <span class="sort-field" @click="onSort('BeginQty')">{{ $t('begin_stock') }}</span>
                                        <i class="fa fa-sort" aria-hidden="true"></i>
                                    </th>
                                    <th class="sorting">
                                        <span class="sort-field" @click="onSort('EndingQty')">{{ $t('ending_stock') }}</span>
                                        <i class="fa fa-sort" aria-hidden="true"></i>
                                    </th>
                                    <th class="sorting">
                                        <span class="sort-field" @click="onSort('Cost')">{{ $t('cost') }}</span>
                                        <i class="fa fa-sort" aria-hidden="true"></i>
                                    </th>
                                    <th class="sorting">
                                        <span class="sort-field" @click="onSort('Price')">{{ $t('price_sale') }}</span>
                                        <i class="fa fa-sort" aria-hidden="true"></i>
                                    </th>
                                    <th class="sorting">
                                        <span class="sort-field" @click="onSort('TotalCost')">{{ $t('total_cost') }}</span>
                                        <i class="fa fa-sort" aria-hidden="true"></i>
                                    </th>
                                    <th class="sorting">
                                        <span class="sort-field" @click="onSort('TotalPrice')">{{ $t('total_price') }}</span>
                                        <i class="fa fa-sort" aria-hidden="true"></i>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret, index) in records" style="vertical-align: middle;" :class="{'bg-default':index%2==0}" :key="index">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{ ret.Num }}</td>
                                    <td><router-link :to="{ name: 'item_edit', params:{ id:ret.Id }}">{{ret.Name}}</router-link></td>
                                    <td>{{itemType(ret.ProductTypeId)}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td class="text-right">{{$number(ret.BeginQty, '0,0.[00]')}}</td>
                                    <td class="text-right" :class="genColor(ret)"><router-link :to="{name: 'report_stock_summary', params: {id:ret.Id}}" target="_blank">{{$number(ret.EndingQty, '0,0.[00]')}}</router-link></td>
                                    <td class="text-right"><router-link :to="{name: 'cost_item_history', params: {id:ret.Id}}">{{$dollar(ret.Cost)}}</router-link></td>
                                    <td class="text-right">{{$dollar(ret.Price)}}</td>
                                    <td class="text-right">{{$dollar(ret.TotalCost)}}</td>
                                    <td class="text-right">{{$dollar(ret.TotalPrice)}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row" v-else-if="viewType==1">
                        <div v-for="(ret,index) in records" :key="index" class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                            <div class="card card-item">
                                <div class="card-body" >
                                    <div class="media">
                                        <template v-if="ret.Image!=null">
                                            <viewer :images="[ret.Image]" :options="{toolbar: false, title: false}">
                                                <img v-for="src in [ret.Image]" :key="src" :src="$base()+ 'image/items/' + ret.Image" style="width: 64px; height: 64px; cursor: pointer;">
                                            </viewer>
                                        </template>
                                        <template v-else>
                                            <img src="/img/no-image.svg" style="width: 64px; height: 64px;"/>
                                        </template>
                                        <div class="media-body">
                                            <div style="padding: 5px 10px;">
                                                <h6 class="mt-0"><router-link :to="{ name: 'item_edit', params:{ id:ret.Id }}">{{ret.Name}}</router-link></h6>
                                                <div>{{ret.Num}}</div>
                                                <div class="row-flex-x" style="justify-content: space-between;">
                                                    <div>Price: {{ret.Price}}</div>
                                                    <div>Cost: <router-link :to="{name: 'cost_item_history', params: {id:ret.Id}}">{{$dollar(ret.Cost)}}</router-link></div>
                                                    <div>Stock: <router-link :to="{name: 'report_stock_summary', params: {id:ret.Id}}" target="_blank">{{$number(ret.Quantity, '0,0.[00]')}}</router-link></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
        <b-modal no-close-on-backdrop centered size="xl"
            modal-class="x-modal"
            title="IMPORT ITEM"
            ref="innerform"
            footer-class="justify-content-between">
            <div class="vl-parent" ref="ldCond">
                <div class="row mb-2">
                    <div class="col-sm-4">                        
                        <button type="button" class="btn btn-primary btn-sm" @click="downloadTemplate()">{{$t('download_template')}}</button>
                    </div>                    
                </div>            
                <div>
                    <div>
                        <ul class="nav text-black mb-3 border-bottom">
                            <li class="nav-item">
                                <button class="nav-link" 
                                    :class="[
                                        {   
                                            'rounded-0 border-primary none-border font-weight-bold bg-transparent': !Tabs(1),
                                            'border-0 bg-transparent': Tabs(1)
                                        }
                                    ]" 
                                    data-target="#nav-home" 
                                    @click.prevent="OnTabs(1)" data-bs-toggle="tab"
                                >{{$t('configure')}}</button>
                            </li>
                            <li class="nav-item">
                                <button class="nav-link"
                                    :class="[
                                        {   
                                            'rounded-0 border-primary none-border font-weight-bold bg-transparent': !Tabs(2),
                                            'border-0 bg-transparent': Tabs(2)
                                        }
                                    ]" 
                                    @click.prevent="OnTabs(2)" 
                                >{{$t('map_field')}}</button>
                            </li>
                            <li class="nav-item">
                                <button class="nav-link"
                                    :class="[
                                        {   
                                            'rounded-0 border-primary none-border font-weight-bold bg-transparent': !Tabs(3),
                                            'border-0 bg-transparent': Tabs(3)
                                        }
                                    ]" 
                                    @click.prevent="OnTabs(3)" 
                                >{{$t('preview')}}</button>
                            </li>
                        </ul>
                    </div>
                    <div class="tab-content border-0" id="nav-tabContent">
                        <div class="col-sm-12" :class="{ 'd-none' :Tabs(1) }">
                            <div class="text-center">
                                <input type="file" class="form-control" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ref="file" style="display: none;" @change="onUpload">
                                <button type="button" class="btn btn-success btn-sm mr-3" @click="$refs.file.click()">{{$t('choose_excel_file')}}</button>
                            </div>
                        </div>
                        <div class="col-sm-12" :class="{ 'd-none' :Tabs(2) }">
                            <div class="h4">{{ $t('item_detail') }}</div>
                            <b-table :fields="field_maps" :items="map_headers" ref="table_map"
                                class="table-sm no-bor"
                            >                
                                <template #head(field)="data">
                                    <span class="d-none"></span>
                                </template>
                                <template #cell(field)="data">                                    
                                    <span class="d-none"></span>
                                </template>               
                                <template #cell(mapped_field)="data">
                                    <b-form-select v-model="data.item.mapped_field" :options="headers">
                                    </b-form-select>
                                </template>               
                            </b-table>
                            <div class="d-flex justify-content-end mt-2">
                                <div>
                                    <b-btn @click="onConfirmMap()" variant="primary">{{ $t('next') }}</b-btn>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12" :class="{ 'd-none' :Tabs(3) }">
                            <div class="row">
                                <div class="col-sm-12">
                                    <b-table :fields="fields" :items="import_confirms" ref="table"
                                        selectable
                                        @row-selected="onRowSelected"
                                        selected-variant="primary"
                                        class="table-sm no-bor">
                                        <template #cell(index)="data">
                                            {{ data.index + 1 }}
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between mt-5">
                                <div>
                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="$refs.table.selectAllRows()" :disabled="imports.length==0"><i class="fa fa-check-square" aria-hidden="true"></i> SELECT ALL</button>&nbsp;
                                    <button type="button" class="btn btn-outline-danger btn-sm" @click="$refs.table.clearSelected()" :disabled="imports.length==0"><i class="fa fa-ban" aria-hidden="true"></i> UNSELECT ALL</button>
                                </div>
                                <div><button type="button" class="btn btn-outline-success btn-sm" :disabled="selectedRows.length==0" @click="onCopy"><i class="fa fa-copyright" aria-hidden="true"></i> COPY</button></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>                    
            <template #modal-footer> 
                <div></div>               
            </template>
        </b-modal>
    </div>
</template>
<script>
    import 'viewerjs/dist/viewer.css'
    import VueViewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(VueViewer)
    export default {
        data: function(){
            return {
                query:{
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    Text: '',
                    ProductTypeId: '',
                    CategoryId: '',
                    SortType: 'ASC',
                    SortField: 'Num',
                    CompanyId: this.$store.state.company.Id
                },
                records:[],
                imports: [],    
                import_confirms: [],
                headers: [],
                selectedRows: [],
                header: { 'Content-Type': 'multipart/form-data' },
                categories: [],
                viewType: 0,
                fields: [
                    { key: 'index', label: 'ល.រ'},
                    { key: 'Num', label: 'លេខកូដ' },
                    { key: 'Name', label: 'ឈ្មោះមុខទំនិញ' },
                    { key: 'SaleDesc' },
                    { key: 'PurchDesc' },
                    { key: 'Price', label: 'តម្លៃ' },
                    { key: 'IncomeAccountName', label: 'IncomeAccount' },
                    { key: 'CostAccountName', label: 'CostAccount' },
                    { key: 'AssetAccountName', label: 'AssetAccount' },
                ],
                field_maps: [
                    { label: 'field', mapped_field: this.$t('item_book_field')},
                    { label: 'header', mapped_field: this.$t('import_file_header') },
                ],
                map_headers: [
                    {
                        label: this.$t("type"),
                        field: "productTypeId",
                        mapped_field: ""
                    },
                    {
                        label: this.$t("code/num"),
                        field: "Num",
                        mapped_field: ""
                    },
                    {
                        label: this.$t("item_name"),
                        field: "Name",
                        mapped_field: ""
                    },
                    {
                        label: this.$t("sale_description"),
                        field: "SaleDesc",
                        mapped_field: ""
                    },
                    {
                        label: this.$t("purchase_description"),
                        field: "PurchDesc",
                        mapped_field: ""
                    },
                    {
                        label: this.$t("price_sale"),
                        field: "Price",
                        mapped_field: ""
                    },
                    {
                        label: this.$t("sale_tax"),
                        field: "IncludeTax",
                        mapped_field: ""
                    },
                    {
                        label: this.$t("income_account"),
                        field: "IncomeAccountName",
                        mapped_field: ""
                    },
                    {
                        label: this.$t("cost_account"),
                        field: "CostAccountName",
                        mapped_field: ""
                    },
                    {
                        label: this.$t("asset_account"),
                        field: "AssetAccountName",
                        mapped_field: ""
                    },
                ],
                activeTab: 1,
            }
        },
        created(){
            if(this.routerNum == 100){
                this.query.Text = this.filter.Text;
            }else{
                this.$store.state.routenum = 100;
            }
            this.$api().post('category/list', { CompanyId: this.$store.state.company.Id }).then(res => {
                if (this.$isValid(res)) {
                    this.categories = res.data.Json.Categories;
                }
            });
            this.toList();
        },
        methods: {
            toList: function(){
                var loading = this.$loading.show();
                this.$api().post('item/list-data', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.records = res.data.Data;
                        this.query.Total = res.data.Total;
                    }
                }).finally(function(){ loading.hide();});
            },
            paging(e){
                this.query.Page = e;
                this.toList();
            },
            viewTypeChange(n){
                this.viewType = n;
                this.$store.state.filter.coa.IsGroup = n==0?false:true;
                this.toList();
            },
            itemType(n){
                return this.$t(this.$productTypes().find(t=>t.id==n).lang);
            },
            genColor(item){
                var ret = '';
                if(item.AlertQty > 0){
                    if(item.EndingQty <= 0) ret = 'bg-danger';
                    else if(item.EndingQty <= item.AlertQty) return 'bg-warning';
                }
                return ret;
            },
            onSort(field){
                this.query.SortField = field;
                if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
                else this.query.SortType = 'ASC';
                this.toList();
            },
            onShow(){
                this.$refs.innerform.show();
            },
            onUpload(){
                var formData = new FormData();
                formData.append('File', this.$refs.file.files[0]);
                formData.append('CompanyId', this.$store.state.company.Id);
                let loading = this.$loading.show();
                this.$api().post('item/upload', formData, this.header).then(res => {
                    if(this.$isValid(res)){
                        this.OnTabs(2);
                        this.imports = res.data.Json.Items;
                        this.headers = res.data.Json.Headers.map((e) => e.key);
                        this.$refs.file.value = null;                                                                                         
                    }
                }).finally(() => { loading.hide(); });
            },
            onRowSelected(items){
                this.selectedRows = items;
            },
            onCopy(){
                let loading = this.$loading.show({
                    container: this.$refs.ldCond
                });
                let selectedItems = [];
                for (let i = 0; i < this.selectedRows.length; i++) {
                    let item = JSON.parse(JSON.stringify(this.selectedRows[i]));
                    item.CompanyId = this.$store.state.company.Id;
                    item.ClientId = this.$store.state.company.ClientId;
                    item.IncludeTax = item.IncludeTax == "Yes" ? 1 : 0;
                    item.productTypeId = item.productTypeId == 'Inventory Part' ? 1 : 2;
                    selectedItems.push(item);
                };                
                this.$api().post('item/import', selectedItems).then(res => {
                    if(this.$isValid(res)){
                        this.$swal.fire("Success", "Upload Item success.", "success");
                        this.selectedRows = [];                        
                        this.imports = [];
                        this.import_confirms = [];
                        this.$refs.innerform.hide();                        
                        this.toList();                        
                        this.map_headers.forEach((e) => e.mapped_field = "");
                        this.OnTabs(1);
                    }
                }).finally(() => { loading.hide(); });
            },
            downloadTemplate() {
                let link = `${this.$base()}export/template-item`;
                window.open(link, "_blank");
            },
            OnTabs(index){
                this.activeTab = index
            },
            Tabs(index){
                return this.activeTab !== index
            },
            onConfirmMap() {
                this.activeTab = 3;
                const headerMapping = this.map_headers.reduce((acc, header) => {
                    acc[header.mapped_field] = header.field;
                    return acc;
                }, {});
                this.import_confirms = this.imports.map(item => {
                    let newItem = {};
                    for (let key in item) {
                        if (headerMapping[key]) {
                        newItem[headerMapping[key]] = item[key];
                        }
                    }
                    return newItem;
                });
                
            }
        },
        computed: {
            routerNum: function(){
                return this.$store.state.routenum;
            },
            filter: function(){
                return this.$store.state.filter;
            }
        },
        destroyed(){
            this.$store.state.filter.Text = this.query.Text;
        }
    }
</script>
<style scoped>
    .table.v-top tr>td{
        vertical-align: middle;
    }
    .bg-default{
        background: #f2f2f2 !important;
    }
    a{
        text-decoration: none;
    }
</style>
